import e from "react";
import { E as a } from "./useClickOutside-726e7c36.mjs";
import { u as E } from "./useClickOutside-726e7c36.mjs";
import { I as i } from "./ImageContext-57256dc1.mjs";
import { u as d } from "./ImageContext-57256dc1.mjs";
import { L as n } from "./LinkContext-0c83848a.mjs";
import { u as P } from "./LinkContext-0c83848a.mjs";
function s({
  children: r,
  LinkComponent: t,
  ImageComponent: o,
  isEmployerSite: m = !1
}) {
  return /* @__PURE__ */ e.createElement(a.Provider, { value: m }, /* @__PURE__ */ e.createElement(n.Provider, { value: t }, /* @__PURE__ */ e.createElement(i.Provider, { value: o }, r)));
}
export {
  s as WifAppProvider,
  E as useEmployerSite,
  d as useImageContext,
  P as useLinkContext
};
//# sourceMappingURL=context.js.map
